import React from "react";

const TelegramCard = () => {
  return (
     <div className="d-flex justify-content-end">

    <div
      style={{
        maxWidth: "320px",
        margin: "20px auto",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        backgroundColor: "#E3F2FD",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        textAlign: "center",
    }}
    className="border border-primary"
    >
      <h5 style={{ marginBottom: "15px", color: "#0A66C2" }}>
        <i
          className="fab fa-telegram"
          style={{ marginRight: "8px", color: "#0088cc" }}
          aria-hidden="true"
          ></i>
        Telegram Support
      </h5>

      <p style={{ fontSize: "14px", marginBottom: "20px", color: "#333" }}>
        For any help, message Telegram or share trades
Message telegram
      </p>

      <a
        href="https://t.me/stockexploderontop"
        target="_blank"
        rel="noopener noreferrer"
        style={{
            display: "inline-block",
            backgroundColor: "#0088cc",
            color: "white",
            padding: "10px 20px",
            borderRadius: "25px",
          fontWeight: "600",
          textDecoration: "none",
          fontSize: "16px",
        }}
        >
        <i
          className="fab fa-telegram"
          style={{ marginRight: "10px" }}
          aria-hidden="true"
          ></i>
        @stockexploderontop
      </a>
    </div>
          </div>
  );
};

export default TelegramCard;
